import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { LocalStorage, SessionStorage } from 'ngx-webstorage';

@Injectable()
export class AuthGuard  {

  constructor(
    private service: AuthenticationService
  ) { }

  canLoad(
    route: Route
  ): boolean {
    let url: string = route.path;
    console.log('Url:' + url);

    return this.checkAuthentication(`/${route.path}`);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkAuthentication(state.url)
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.canActivate(route, state);
  }

  checkAuthentication(returnUrl: string): boolean {
    if (this.service.isLoggedIn) {
      var permissions = this.service.userRoles;
      if (permissions.length == 0) {
        //check db for roles as user should have roles
        var storedPermissions = sessionStorage.getItem('user_roles');
        permissions = JSON.parse(storedPermissions);
      }
      if (permissions.length > 0) {
        for (let permission of permissions) {
          var permissionUrl = this.convert(permission);
          if (permissionUrl == returnUrl) {
            return true;
          }
        };
      } else {
        this.service.logout(returnUrl);
        return false;//change to false
      };
      return false;//change to false
    } else {
      this.service.logout(returnUrl);
      return false;
    }
  }

  convert(permission: string): string {
    switch (permission) {
      case 'Admin':
        return '/admin';
      case 'Configuration':
        return '/configuration';
      case 'Dispatch':
        return '/curtailment';
      case 'Status':
        return '/status';
      case 'Reporting':
        return '/reporting';
      case 'UserManagement':
        return '/admin/userManagement';
      case 'RoleManagement':
        return '/admin/roleManagement';
      case 'LCGGroup':
        return '/configuration/lcgMaintenance';
      case 'LCGMapGroup':
        return '/configuration/lcgMapMaintenance';
      case 'SubstationGroup':
        return '/configuration/substationMaintenance';
      case 'MessageCenter':
        return '/configuration/message-center';
      case 'LcgSlapAbank':
        return '/configuration/lcgSlapAbank';
      case 'SLAPGroup':
        return '/configuration/slapMaintenance';
      case 'EmergencyOptOut':
        return '/configuration/emergencyOptOut';
      case 'DeviceOptOut':
        return '/configuration/deviceOptOutSet';
      case 'TxOffAirMonitor':
        return '/configuration/txOffAirMonitors';
      case 'Curtailment':
        return '/curtailment/curtailments';
      case 'NewCurtailment':
        return '/curtailment/newCurtailment';
      case 'TransmitterStatus':
        return '/status/transmitterStatus';
      case 'Setup':
        return '/configuration/setup';
      case 'CseDecodeLogger':
        return '/status/cseDecodeLogger'
      case 'CseConsoleLogger':
        return '/status/cseConsoleLogViewer';
      case 'TransmissionQueue':
        return '/status/transmissionQueue';
      case 'AbankGroup':
        return '/configuration/abankMaintenance';
      case 'LcgSlapAbankStatus':
        return '/status/lcgSlapAbank';
      case 'LogonHistory':
        return '/reporting/logonHistory';
      case 'TxStateHistory':
        return '/reporting/txStatusHistory';
      case 'TxBacklogEst':
        return '/reporting/txBacklog';
      case 'DeviceMonitorMaintenance':
        return '/configuration/deviceMonitors';
      case 'DeviceMonitor':
        return '/status/deviceMonitor';
      default:
        break;
    }
  }
}
